import { useState, useCallback, useMemo, useEffect } from "react";
import { LanguageContext, type Language, getDirection, t as translate } from "@/lib/i18n";

const STORAGE_KEY = "app-language";

export default function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLangState] = useState<Language>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === "he" || stored === "ru" || stored === "ar") return stored;
    } catch {}
    return "he";
  });

  const dir = getDirection(lang);

  const setLang = useCallback((next: Language) => {
    setLangState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch {}
  }, []);

  // Update document direction
  useEffect(() => {
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
  }, [dir, lang]);

  const tFn = useCallback((key: Parameters<typeof translate>[0]) => translate(key, lang), [lang]);

  const value = useMemo(() => ({ lang, dir, setLang, t: tFn }), [lang, dir, setLang, tFn]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}
